export default "__VITE_ASSET__54311c71__"